import { api } from './client';

export interface SshKey {
  id: string;
  type: string;
  key: string;
  comment: string;
  added_at: string;
}

export const fetchSshKeys = (username: string): Promise<SshKey[]> =>
  api.get<{ keys: SshKey[] }>(`/users/${username}/ssh-keys`).then((r) => r.data.keys);

export const addSshKey = (username: string, key: string): Promise<SshKey> =>
  api.post<SshKey>(`/users/${username}/ssh-keys`, { key }).then((r) => r.data);

export const removeSshKey = (username: string, keyId: string): Promise<void> =>
  api.delete(`/users/${username}/ssh-keys/${keyId}`).then(() => undefined);
